import React from "react";

export const levelColor = (pct) =>
  pct >= 85 ? "#ef4444" : pct >= 60 ? "#10b981" : pct >= 30 ? "#f59e0b" : "#ef4444";

export const levelLabel = (pct) =>
  pct >= 85 ? "High" : pct >= 60 ? "Normal" : pct >= 30 ? "Low" : "Critical";

export const effColor = (score) =>
  score >= 80 ? "#10b981" : score >= 60 ? "#f59e0b" : "#ef4444";

export const severityColor = (s) => {
  switch (s) {
    case "Critical": return "#ef4444";
    case "Warning":  return "#f59e0b";
    case "Info":     return "#3b82f6";
    default:         return "#94a3b8";
  }
};

export const severityBg = (s) => {
  switch (s) {
    case "Critical": return "#fee2e2";
    case "Warning":  return "#fef3c7";
    case "Info":     return "#dbeafe";
    default:         return "#f1f5f9";
  }
};

export const statusColor = (s) => {
  switch (s) {
    case "Running":  case "Active":   case "Online":   return "#10b981";
    case "Standby":  case "Seasonal": return "#f59e0b";
    case "Offline":                   return "#ef4444";
    default:                          return "#94a3b8";
  }
};

export const statusBg = (s) => {
  switch (s) {
    case "Running":  case "Active":   case "Online":   return "#d1fae5";
    case "Standby":  case "Seasonal": return "#fef3c7";
    case "Offline":                   return "#fee2e2";
    default:                          return "#f1f5f9";
  }
};

// Animated tank level fill
export const TankBar = ({ pct, height = 80, width = 36 }) => {
  const col = levelColor(pct);
  return (
    <div style={{ width, height, background: "#e2e8f0", borderRadius: 6, overflow: "hidden", position: "relative", border: `1px solid ${col}44` }}>
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        height: `${pct}%`,
        background: `linear-gradient(180deg, ${col}99, ${col})`,
        borderRadius: "0 0 5px 5px",
        transition: "height 0.6s ease",
      }} />
      <div style={{
        position: "absolute", inset: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "0.72rem", fontWeight: 700, color: pct > 50 ? "white" : col,
      }}>
        {pct}%
      </div>
    </div>
  );
};

export const MiniBar = ({ value, max = 100, color = "#3b82f6", height = 6 }) => (
  <div style={{ background: "#e2e8f0", borderRadius: 99, height, overflow: "hidden" }}>
    <div style={{ width: `${Math.min((value / max) * 100, 100)}%`, background: color, height: "100%", borderRadius: 99 }} />
  </div>
);

export const HealthRing = ({ value, size = 80, stroke = 8, color }) => {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (value / 100) * circ;
  const col = color || (value >= 75 ? "#10b981" : value >= 50 ? "#f59e0b" : "#ef4444");
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={col} strokeWidth={stroke}
        strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round" />
    </svg>
  );
};

export const KpiCard = ({ label, value, unit, color = "#3b82f6", icon: Icon, sub, alert }) => (
  <div className="wm-kpi-card" style={{ borderTopColor: color }}>
    <div className="wm-kpi-top">
      {Icon && <div className="wm-kpi-icon" style={{ background: `${color}18`, color }}><Icon size={18} /></div>}
      <span className="wm-kpi-label">{label}</span>
    </div>
    <div className="wm-kpi-value" style={{ color }}>{value}{unit && <span className="wm-kpi-unit"> {unit}</span>}</div>
    {sub && <div className="wm-kpi-sub">{sub}</div>}
    {alert && <div className="wm-kpi-alert">{alert}</div>}
  </div>
);

export const SeverityBadge = ({ severity }) => (
  <span className="wm-sev-badge" style={{ background: severityBg(severity), color: severityColor(severity) }}>
    {severity}
  </span>
);

export const StatusBadge = ({ status }) => (
  <span className="wm-status-badge" style={{ background: statusBg(status), color: statusColor(status) }}>
    {status}
  </span>
);
